module.exports = __webpack_public_path__ + "assets/img/Commercial_Projects@2x.f9bf7cb2.png";